import React from 'react'
import '../index.css'
import { Box, Divider, Grid2, Paper, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { LOGOUT } from '../actions/types';

const Main = (props) => {
    const {id} = useParams();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    let location = useLocation()
    const active = { backgroundColor: '#4DA235', padding: 1, borderRadius: 3, marginLeft: 4, marginRight: 4, marginBottom: 2 }
    const inActive = { padding: 1, borderRadius: 3, marginLeft: 4, marginRight: 4, marginBottom: 2 }
    return (
        <Box elevation={1} className="headerLayout" flex={1}>
            <Grid2 container>
                <Grid2 size={2}>
                    <Box sx={location.pathname === '/dashboard' ? active : inActive}>
                        <Typography onClick={() => {navigate('/dashboard')}} color={location.pathname === '/dashboard' ? 'white': 'black'} sx={{ cursor: 'pointer' }}>Dashboard</Typography>
                    </Box>
                    <Box sx={location.pathname === '/leads' ? active : inActive}>
                        <Typography onClick={() => {navigate('/leads')}} sx={{ cursor: 'pointer' }} color={location.pathname === '/leads' ? 'white': 'black'}>Leads</Typography>
                    </Box>
                    <Box sx={location.pathname === '/assignmentlogs' ? active : inActive}>
                        <Typography onClick={() => {navigate('/assignmentlogs')}} sx={{ cursor: 'pointer' }} color={location.pathname === '/assignmentlogs' ? 'white': 'black'}>Assignment Log</Typography>
                    </Box>
                    <Divider flexItem />
                    <Box>
                        <Box sx={{ padding: 1, borderRadius: 3, marginLeft: 4, marginRight: 4, marginBottom: 2 }}>
                            <Typography onClick={() => {dispatch({type: LOGOUT}); navigate("/")}} sx={{ cursor: 'pointer' }}>Logout</Typography>
                        </Box>
                    </Box>

                </Grid2>
                <Grid2 size={10} sx={{ background: '#F5F6FA', minHeight: '85vh' }}>
                    {props.children}
                </Grid2>
            </Grid2>

        </Box>
    )
}

export default Main;
